import React from 'react';
import Button from '@mui/material/Button';
import { CustomDialog } from '../../Component/Dialog';

const LanguageChangeDialog = ({ isOpen, onCancel, onConfirm, loadMoreClass }) => {
  return (
    <CustomDialog
      isOpen={isOpen}
      size={'sm'}
      title={'Confirm language change'}
      contents={
        <>
          <p className={'s-text'}>
            Changing from one coding language to another will wipe any code in the current selected
            language. If you want to keep the current code, you should copy and paste it somewhere
            before swapping languages (e.g. in a note on the canvas).
          </p>
          <p className={'s-text'}>Are you sure you want to continue?</p>
        </>
      }
      buttons={
        <>
          <Button variant={'outlined'} onClick={onCancel}>
            Cancel
          </Button>
          <Button variant={'contained'} className={loadMoreClass} onClick={onConfirm}>
            Continue
          </Button>
        </>
      }
    />
  );
};

export default LanguageChangeDialog;
